import { render } from "./MessageComposer.vue?vue&type=template&id=0fc6bbb6&scoped=true"
const script = {}

import "./MessageComposer.vue?vue&type=style&index=0&id=0fc6bbb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc6bbb6"]])

export default __exports__